import { Controller } from 'react-hook-form';
import { useEffect, useState } from 'react';
import Select from 'react-select';
import type { PersonaFieldProps } from 'src/pages/ConfigurationPage/PersonaTab/PersonaForm/DynamicFields/personaFieldProps';

export const ExcludedLanguagesField = ({
  field,
  data,
  control,
  readonly,
  setValue,
  watch,
}: PersonaFieldProps<'pf_excluded_languages'>) => {
  const [selectValues, setSelectValues] = useState([]);
  const [options, setOptions] = useState([]);

  const defaultLanguage = watch('pf_default_language');
  const fieldValues = watch('pf_excluded_languages');

  useEffect(() => {
    if (field) {
      const filteredOptions = field.options.filter((option) => {
        return option.key !== defaultLanguage?.key;
      });

      setOptions(filteredOptions);
      const excludedOptions: typeof filteredOptions = [];

      if (data) {
        filteredOptions.forEach((option) => {
          if (data.includes(option.key)) {
            excludedOptions.push(option);
          }
        });
        setValue('pf_excluded_languages', excludedOptions);
        setSelectValues(excludedOptions);

        return;
      }

      if (readonly) {
        setValue('pf_excluded_languages', []);
        setSelectValues([]);
        return;
      }
      setSelectValues(excludedOptions);
    } else {
      setValue('pf_excluded_languages', []);
      setSelectValues([]);
    }
  }, [field, data, readonly]);

  useEffect(() => {
    const filteredOptions = field.options.filter((option) => {
      return option.key !== defaultLanguage?.key;
    });
    let filteredSelected;

    if (fieldValues?.length) {
      filteredSelected = fieldValues.filter((option) => {
        return option.key !== defaultLanguage?.key;
      });
    } else {
      if (selectValues?.length) {
        filteredSelected = selectValues.filter((option) => {
          return option.key !== defaultLanguage?.key;
        });
      }
      if (data?.length) {
        filteredSelected = filteredOptions.filter((option) => {
          return data.includes(option.key) && option.key !== defaultLanguage?.key;
        });
      }
    }

    setOptions(filteredOptions);
    setSelectValues(filteredSelected);
    setValue('pf_excluded_languages', filteredSelected);
  }, [defaultLanguage]);

  return field && options.length ? (
    <div className={'flex flex-1 flex-col gap-[5px]'}>
      <div>
        <p className={'text-ebony_opacity_30 text-xs font-medium'}>Excluded languages</p>
      </div>
      <div>
        <Controller
          control={control}
          name="pf_excluded_languages"
          render={() => (
            <Select
              isMulti
              defaultValue={selectValues}
              getOptionLabel={(option) => option.value}
              getOptionValue={(option) => option.key}
              isDisabled={readonly}
              value={selectValues}
              onChange={(values) => {
                setSelectValues([...values]);
                setValue('pf_excluded_languages', [...values]);
              }}
              name="pf_default_language"
              placeholder={'No limitations'}
              options={options}
              classNamePrefix="select"
              styles={{
                placeholder: (baseStyles) => ({
                  ...baseStyles,
                  color: '#B8C1C6',
                }),
                control: (baseStyles, state) => ({
                  ...baseStyles,
                  boxShadow: 'none',
                  borderColor: state.isFocused ? '#a498ff80!important' : '#E3E6E8',
                  fontFamily: 'Bai Jamjuree',
                  fontSize: '14px',
                  fontWeight: '500',
                  background: state.isDisabled ? '#fff' : baseStyles.background,
                  opacity: state.isDisabled ? '0.5' : baseStyles.opacity,
                }),
                option: (baseStyles, state) => ({
                  ...baseStyles,
                  background: state.isSelected || state.isFocused ? '#a498ff1a' : baseStyles.color,
                  color: state.isSelected ? 'rgba(5, 5, 13);' : 'rgba(5, 5, 13, 0.50);',
                  fontFamily: 'Bai Jamjuree',
                  fontSize: '14px',
                  fontWeight: '500',
                }),
                multiValue: (baseStyles) => ({
                  ...baseStyles,
                  backgroundColor: '#a498ff1a',
                  border: '1px solid #a498ff80',
                  borderRadius: '5px',
                }),
                multiValueRemove: (baseStyles) => ({
                  ...baseStyles,
                  '&:hover': {
                    backgroundColor: 'transparent',
                  },
                }),
              }}
            />
          )}
        />
      </div>
    </div>
  ) : null;
};
